import type { Authentication, UserSliceState } from "@/features/auth/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: UserSliceState = {
  isAuthenticated: false,
  isLoading: false,
  error: null,
  loggingOut: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setCredentials: (state, { payload }: PayloadAction<Authentication>) => {
      Object.assign(state, {
        ...payload,
        isAuthenticated: true,
        error: null,
        displayName: `${payload?.firstName} ${payload?.lastName}`,
      });
    },
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload;
    },
    setError: (state, { payload }: PayloadAction<string | null>) => {
      state.error = payload;
    },
    logout: (state) => {
      Object.assign(state, initialState);
      state.loggingOut = true;
    },
  },
});

export const { setCredentials, setLoading, setError, logout } =
  userSlice.actions;
export default userSlice.reducer;
